const LOADING_MESSAGE = "Carregando avaliações…";

function setReviewsBusy(isBusy) {
  const region = document.querySelector(".js-reviews");
  if (region) {
    region.setAttribute("aria-busy", isBusy ? "true" : "false");
  }
}

$(() => {
  $(".js-rate-link").on("click", function () {
    setReviewsBusy(true);

    const loadingHTML = `
      <p id="js-reviews-status" class="sr-only" aria-live="polite">${LOADING_MESSAGE}</p>
      <div class="empty-reviews">
        <div class="loader" aria-hidden="true"></div>
        <p class="sr-only">${LOADING_MESSAGE}</p>
      </div>
    `;

    const reviewsRoot = document.querySelector(".js-reviews");
    if (reviewsRoot) reviewsRoot.innerHTML = loadingHTML;

    document.querySelectorAll(".js-filter-pill").forEach((pill) => {
      pill.classList.remove("company__filter-pill--active");
      pill.removeAttribute("aria-current");
    });
    this.classList.add("company__filter-pill--active");
    this.setAttribute("aria-current", "true");
  });

  $(".js-load-more-reviews").on("click", function () {
    if (!this.dataset.remote) return;
    setReviewsBusy(true);
    this.textContent = "Carregando...";
    this.style.pointerEvents = "none";
  });
});

export { setReviewsBusy };
